import React, {useCallback, useEffect, useState} from 'react';

import Bubble from '../Bubble/Bubble';
import Floater from '../Floater/Floater';
import styles from './BubbleWrapper.module.scss';
import useAnimatedVisibility from '../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';

const BubbleWrapper = props => {
    const {bubble, event, user: currentUser, infoPosition, expandedBubble, onExpandBubble} = props,
        [user, setUser] = useState(),
        [recentlyActive, setRecentlyActive] = useState(false),
        {mounted, visible, showing, hiding, onTransitionEnd} = useAnimatedVisibility({
            visible: !!currentUser,
            timeout: 6000,
        });

    useEffect(() => {
        if (currentUser) setUser(currentUser);
    }, [currentUser]);

    useEffect(() => {
        if (expandedBubble && expandedBubble == user?.id) {
            setRecentlyActive(true);
        } else if (recentlyActive) {
            let timeout = setTimeout(() => setRecentlyActive(false), 500);
            return () => clearTimeout(timeout);
        }
    }, [expandedBubble]);

    if (!mounted) return null;

    return (
        <Floater
            className={[
                styles.bubble,
                visible ? styles.visible : styles.hidden,
                showing ? styles.showing : '',
                hiding ? styles.hiding : '',
                recentlyActive ? styles.recentlyActive : '',
            ].join(' ')}
            {...bubble}
            // style={{zIndex: bubble.zIndex}}
            onTransitionEnd={onTransitionEnd}>
            <Bubble event={event} user={user} infoPosition={infoPosition} expandedBubble={expandedBubble} onExpandBubble={onExpandBubble} />
        </Floater>
    );
};

export default BubbleWrapper;
